import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
    selector: 'xui-error-message',
    templateUrl: './app-error-message.component.html',
    styleUrls: ['./app-error-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppErrorMessageComponent {
  readonly errorMessage = input('');

  get hasErrorMessage(): boolean {
    return this.errorMessage().length > 0;
  }
}
